<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name" dataKey="id"
                              filter :placeholder="$t('AppOrganizationSettings.Organização')" class="dropdown-250">
                    </Dropdown>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div v-show="selectedOrg" class="organization-settings">
                    <AppOrganizationSettingsCard v-if="selectedOrg" :organization="selectedOrg"
                                                 :getting-data="loading"
                                                 @save="updateOrganization"/>
                </div>
                <div v-if="!selectedOrg"  class="d-flex justify-content-center mt-5">
                    <div class="text-center flex-column kt-font-lg">
                        <div class="font-weight-bold kt-font-xl">
                            {{ $t('AppOrganizationSettings.Selecione uma organização para editá-la') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import AppOrganizationSettingsCard from "./AppOrganizationSettingsCard.vue";

import OrganizationsService from "@/services/OrganizationsService";

export default {
    mounted() {
        this.organizationsService = new OrganizationsService();
        this.getOrganizations();
    },
    data() {
        return {
            organizationsService: null,
            loading: false,
            organizations: [],
            selectedOrg: null,
            storedChosenOptions: null
        }
    },
    methods: {
        getOrganizations() {
            this.organizationsService.getAllV3()
                .then((response) => {
                    this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
                    this.selectSavedOrg();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOrganizationSettings.Não foi possivel buscar as organizações'),
                        life: 5000
                    });
                })
        },
        selectSavedOrg() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.organizations.filter(a => this.storedChosenOptions['clients'].some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        updateOrganization(tz) {
            let body = {
                timezone: tz
            }

            this.organizationsService.updateOrganization(this.selectedOrg.id, body)
                .then(() => {
                    this.goBack();
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppOrganizationSettings.Organização atualizada com sucesso'),
                        life: 5000
                    });
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOrganizationSettings.Houve um erro ao atualizar a organização'),
                        life: 5000
                    });
                })
        },
        goBack() {
            this.$router.go(-1);
        }
    },
    watch: {
        selectedOrg: function (val) {
            if (val) {
                this.saveChosenOptionsToLocalStorage();
            }
        },
    },
    components: {
        Dropdown, AppOrganizationSettingsCard
    }
}
</script>

<style scoped>
.dropdown-250 {
    width: 250px;
}
</style>
